<template>
  <div class="mt-md-5 mb-md-5 main-div p-1" >

    <div class="star star-one text-white"></div>

    <div class="star star-two text-white"></div>

    <div class="star star-three text-white"></div>

    <div style="position: absolute">
       
      <img alt="js" src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/6bc5a982f6672d01ba83afde09ca67e19f95d2f3/imgs/rocket.svg" class="rocket-body" width="80px" />

      <div class="exhaust-flame"></div>

      <div class="star star-four text-white"></div>
      <div class="star star-five text-white"></div>
      <div class="star star-six text-white"></div>
      
    </div>
  </div>
</template>
<script>
export default {
  name: "RocketAni",
  data() {
		return {
			host: process.env.VUE_APP_HOST,
		};
	},
};
</script>
<style  scoped>
.main-div {
  transform: rotate(80deg);
}

.rocket-body {
  position: relative;
  top: -100px;
  left: 75%;
  animation: rocket-run 0.8s infinite;
}

.exhaust-flame {
  position: absolute;
  top: -24%;
  width: 8px;
  background: linear-gradient(to bottom, transparent 10%, #a4bb21 100%);
  border-radius: 0 0 100px 100px;
  height:50px;
  left: 122%;
  z-index: -1000;
  transform: rotate(180deg);
  animation: exhaust-flame 0.2s infinite;
}

.star {
  width: 2px;
  height: 20px;
  background: lightcyan;
  transform: rotate(1deg);
  border-radius: 50% 50% 50% 50%;
  position: relative;
}
.star-one {
  top: -50px;
  left: 20%;
  animation: star-one 2s infinite;
}
.star-two {
  position: relative;
  top: -30px;
  left: 50%;
  animation: star-two 2s infinite;
}
.star-three {
  position: relative;
  top: -100px;
  left: 60%;
  animation: star-three 0.7s infinite;
}
.star-four {
  position: relative;
  top: -200px;
  left: 90%;
  animation: star-four 1s infinite;
}
.star-five {
  position: relative;
  top: -220px;
  left: 150%;
  animation: star-five 0.7s infinite;
}
.star-six {
  position: relative;
  top: -260px;
  left: 120%;
  animation: star-six 0.7s infinite;
}

@keyframes exhaust-flame {
  0% {
    background: linear-gradient(to bottom, transparent 10%, #3dee26 100%);
  }
  50% {
    background: linear-gradient(to bottom, transparent 8%, #f5f5f5 100%);
  }
  75% {
    background: linear-gradient(to bottom, transparent 12%, #f5f5f5 100%);
  }
}

@keyframes star-one {
  from {
    opacity: 1;
  }
  to {
    top: 100px;
    transform: scale(1);
    transform: scale(1);
    opacity: 0.2;
  }
}
@keyframes star-two {
  from {
    opacity: 1;
  }
  to {
    top: 80px;
    transform: scale(1);
    opacity: 0.2;
  }
}
@keyframes star-three {
  from {
    opacity: 1;
  }
  to {
    top: 60px;
    transform: scale(1);
    opacity: 0.2;
  }
}
@keyframes star-four {
  from {
    opacity: 1;
  }
  to {
    top: -10px;
    transform: scale(1);
    opacity: 0.2;
  }
}
@keyframes star-five {
  from {
    opacity: 1;
  }
  to {
    top: -70px;
    transform: scale(1);
    opacity: 0.2;
  }
}
@keyframes star-six {
  from {
    opacity: 1;
  }
  to {
    top: -60px;
    transform: scale(1);
    opacity: 0.2;
  }
}

@keyframes rocket-run {
  0% {
    transform: translate3d(0px, 0px, 0);
  }
  50% {
    transform: translate3d(0px, -4px, 0);
  }
  100% {
    transform: translate3d(0px, 0px, 0);
  }
}
</style>